import { render, staticRenderFns } from "./PriceSectionDesktop.vue?vue&type=template&id=38a51fbb&scoped=true&"
import script from "./PriceSectionDesktop.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceSectionDesktop.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PriceSectionDesktop.vue?vue&type=style&index=0&id=38a51fbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a51fbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a51fbb')) {
      api.createRecord('38a51fbb', component.options)
    } else {
      api.reload('38a51fbb', component.options)
    }
    module.hot.accept("./PriceSectionDesktop.vue?vue&type=template&id=38a51fbb&scoped=true&", function () {
      api.rerender('38a51fbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/PriceSectionDesktop.vue"
export default component.exports